<div class="modal-header">
  <h4 class="modal-title" i18n>Earn referral discounts</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.close()"></button>
</div>
<div class="modal-body">

  <p i18n>For every 3 friends that sign up, make and pay an order you earn 5% referral discount that you can use with
    your future orders.</p>
  <label class="form-label" i18n>Referral link</label>
  <div class="input-group mb-3">
    <input type="text" class="form-control" [(ngModel)]="referralLink" readonly>
    <button class="btn btn-primary" (click)="copyLink()"><fa-icon [icon]="fa.faCopy" style="color: #fff; position: relative; top: -2px;"></fa-icon></button>
  </div>
  <button *ngIf="canShare" type="button" class="btn btn-primary w-100 mb-3" (click)="share()">
    <fa-icon [icon]="fa.faShareSquare" style="color: #fff;"></fa-icon>&nbsp;
    <span i18n>Share</span>
  </button>

  <label class="form-label" i18n>Your referrals</label>
  <table class="table table-striped">
    <thead>
      <tr>
        <th i18n>Signed up</th>
        <th i18n>Orderred</th>
        <th i18n>Rewarded</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let referral of referrals">
        <td>{{ referral.created_at | date: 'short' }}</td>
        <td>{{ referral.first_order_at | date: 'short' }}</td>
        <td>
          <ng-component *ngIf="referral.referral_discount_id" i18n>Yes</ng-component>
          <ng-component *ngIf="referral.referral_discount_id" i18n>No</ng-component>
        </td>
      </tr>
    </tbody>
  </table>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="activeModal.close()" i18n>Close</button>
</div>